import React from 'react';
import { SnackbarProvider } from 'notistack';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { Switch } from 'react-router-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import Slide from '@material-ui/core/Slide';

import configureStore, { history } from './redux/store';
import AppWrapper from './@jumbo/components/AppWrapper';
import AppContextProvider from './@jumbo/components/contextProvider/AppContextProvider';
import AuthContextProvider from './@jumbo/components/context/AuthContext';
import Routes from './routes';
import axios from 'axios';

export const store = configureStore();

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
const App = () => (
  <Provider store={store}>
    <AuthContextProvider>
      <SnackbarProvider
        maxSnack={1}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        TransitionComponent={Slide}>
        <ConnectedRouter history={history}>
          <AppContextProvider>
            <AppWrapper>
              <Switch>
                <Routes />
              </Switch>
            </AppWrapper>
          </AppContextProvider>
        </ConnectedRouter>
      </SnackbarProvider>
    </AuthContextProvider>
  </Provider>
);

export default App;
